var React = require('react');

function Selected (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"data-id":"outer-circle","cx":"12","cy":"12","r":"12","key":0}),React.createElement("circle",{"data-id":"inner-circle","cx":"12","cy":"12","r":"6","key":1})]);
}

Selected.defaultProps = {"viewBox":"0 0 24 24","focusable":"false","aria-hidden":"true"};

module.exports = Selected;

Selected.default = Selected;
